/**
 * Calendar-date helpers of the domain (`YYYY-MM-DD`, no time zone: «today» is computed by the
 * client in the user's zone before calling them).
 */
function toUtc(date) {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day));
}
/**
 * The date `days` working days (Monday to Friday, no holidays) after `date`: the default
 * follow-up date of «S · Seguimiento» is three working days after today (docs/04 §2 rule 4).
 */
export function addBusinessDays(date, days) {
    const current = toUtc(date);
    let left = days;
    while (left > 0) {
        current.setUTCDate(current.getUTCDate() + 1);
        const weekday = current.getUTCDay();
        if (weekday !== 0 && weekday !== 6)
            left -= 1;
    }
    return current.toISOString().slice(0, 10);
}
//# sourceMappingURL=dates.js.map